import {  useEffect, useState } from "react";
import { Link,  useParams } from "react-router-dom";
import {  addSolutionLocations, getSolutionSingleCard } from "../api/UserRequest";
import logo from "../assests/zeeqr-black.svg";
import { Helmet } from "react-helmet";

import { Spin } from "antd";
import { LoadingOutlined, RedditSquareFilled } from "@ant-design/icons";
import DigitalInterfaceTheme from "../components/solutionCards/digitalResumeThemes/DigitalInterfaceTheme";
import FormQrCodeInterfaceTheme from "../components/solutionCards/formQrCodeThemes/FormQrCodeInterfaceTheme";
import MultiUrlInterFaceTheme from "../components/solutionCards/multiUrlThemes/MultiUrlInterFaceTheme";
import ImageGalleryTheme from "../components/solutionCards/galleryImageThemes/ImageGalleryTheme";
import MenuTheme from "../components/solutionCards/menuCardThemes/MenuTheme";
import SocialmediaTheme from "../components/solutionCards/socialMeidaThemes/SocialmediaTheme";
import AppdownloadTheme from "../components/solutionCards/appDownloadThemes/AppdownloadTheme";
import FaceBookTheme from "../components/solutionCards/facebookThemes/FaceBookTheme";
import MedicalalertTheme from "../components/solutionCards/medicalTagThemes/MedicalalertTheme";
import PdfGalleryTheme from "../components/solutionCards/pdfGalleryThemes/PdfGalleryTheme";
import PetTagUrlTheme from "../components/solutionCards/petTagTheme/PetTagTheme";
import ProductLandingTheme from "../components/solutionCards/productLandingThemes/ProductLandingTheme";

import EventQrTheme from "../components/solutionCards/EventPageThemes/EventQrTheme";
import RedirectSolutionForm from "../components/solutionCards/redirectSolution/RedirectSolutionForm";
import axios from "axios";

const metaDecorator = require("../data/metaDecorator.json");

function SolutionCardPage() {
      const params = useParams();
      // console.log(params);
      
   const [card, setCard] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
  /* ----------- fetching card details and after that take location ----------- */

  useEffect(() => {
    const getDetails = async () => {
      try {
        setIsLoading(true)
        // console.log(params.id, '11111111111');

        const { data } = await getSolutionSingleCard(params.id);
        // console.log(data);
      if (data.success) {
          setCard(data.data); // Set the card data from response

          // if(data.data.cardType !== "trial") {
          
          //   const liveLocation = await axios.get('https://ipapi.co/json')
          //           await   addSolutionLocations(data.data._id, liveLocation.data)
          // }
        } else {
          setCard(null); // Set to null if not successful
        }
        
     
      } catch (error) {
          console.log(error);
        setCard(null); // Set to null on error
      } finally {
        setIsLoading(false)
      }
    };
    getDetails();
  }, [params.id]);


  return (
    <div>
      {isLoading ? (
        <div className="w-full h-screen flex items-center justify-center">
       
            <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    fontSize: 60,
                    color: "black",
                  }}
                  spin
                />
              }
            />
       
        </div>
      ) : card? (
      <div>
       { card.formType === "digital_resume" ? (
        <DigitalInterfaceTheme card={card}/>
       ) : card.formType === "multi_url" ? (
        <MultiUrlInterFaceTheme card={card}/>
       ) : card.formType === "image_gallery" ? (
        <ImageGalleryTheme card={card}/>
       ) : card.formType === "menu_qr" ? (
        <MenuTheme card={card}/>
       ) : card.formType === "social_media" ? (
        <SocialmediaTheme card={card}/>
       ) : card.formType === "app_download" ? (
        <AppdownloadTheme card={card}/>
       ) : card.formType === "facebook" ? (
        <FaceBookTheme card={card}/>
       ) : card.formType === "medical_alert" ? (
        <MedicalalertTheme card={card}/>
       ) : card.formType === "pdf_gallery" ? (
        <PdfGalleryTheme card={card}/>
       ) : card.formType === "pet_tag" ? (
        <PetTagUrlTheme card={card}/>
       ) : card.formType === "product_landing" ? (
        <ProductLandingTheme card={card}/>
       ) : card.formType === "event_ticket" ? (
        <EventQrTheme card={card}/>
       ) : card.formType === "form_qrcode" ? (
        <FormQrCodeInterfaceTheme card={card}/>
       ) : card.formType === "whatsapp_simpleForm" ? (
        <RedirectSolutionForm card={card}/>
       ) : card.formType === "sms_simpleForm" ? (
        <RedirectSolutionForm card={card}/>
       ) : card.formType === "email_simpleForm" ? (
        <RedirectSolutionForm card={card}/>
       ) : card.formType === "text_simpleForm" ? (
        <RedirectSolutionForm card={card}/>
       ) : card.formType === "wifi_simpleForm" ? (
        <RedirectSolutionForm card={card}/>
       ) : card.formType === "upi_simpleForm" ? (
        <RedirectSolutionForm card={card}/>
       ): null }
        </div>
      ) : (
        <div className="w-full h-screen flex flex-col items-center justify-center">
          <img src={logo} alt="" />
          <h1 className="font-bold mt-2">
            This card is not valid/card has expired!
          </h1>
          <p className="mt-1">Please contact the admin</p>
          <Link to={"https://wa.me/+971505363704?text=Hi%2C"} target="blank">
            <button className="p-2 mt-3 border-2 rounded-xl border-black">
              Get In Touch
            </button>
          </Link>
        </div>
      )}
      {/* <Helmet>
        <meta charSet="utf-8" />
        <title>{card?.name}</title>
        <meta name="description" content={card?.companyDesignation} />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={card.profileImage}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={card.profileImage}
        />
        <meta property="og:title" class="notranslate" content={card.name} />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={
            metaDecorator.hostname +
            window.location.pathname +
            window.location.search
          }
        />
        <meta
          property="og:description"
          class="notranslate"
          content={card.companyDesignation}
        />
        <meta property="og:image" content={card.profileImage} />
      </Helmet> */}
    </div>
  );
}

export default SolutionCardPage;
